import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

/**
 * `/master/device` dan `/master/device_log`. Semua method balikin response axios
 * UTUH, jadi jalur bacanya `res.data.data`.
 *
 * Bentuk satu baris device, dibaca dari pemanggilnya:
 * - `devcId` id device (src/views/report/OperationModeSummary.vue:268)
 * - `devcUniqueId` id fisik yang dikirim ke endpoint `/series/*` sebagai `device[]`
 *   (src/store/asset.js:123)
 * - `devcType` 'gps' | 'rpm' | 'ae' | 'flowmeter' | 'temperature' | 'powermeter'
 *   (src/store/asset.js:119)
 * - `devcMassId` id asset pemiliknya
 * - `devcName` nama tampil (src/views/master/device/Index.vue:411)
 *
 * Blok `// Series` di ekor file mukul `/series/base/*`, bukan `/master/*` — bentuk
 * balasannya beda dan bukan MasterListBody.
 */
export default {
  // Device Log
  getDeviceLogs(config) {
    return axiosInstance.get('/master/device_log', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getLogInformation(param) {
    return axiosInstance.get(`/master/device_log?findField=${param.findField}&findValue=${param.findValue}&page=${param.page}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  getLogInformationByDate(param) {
    return axiosInstance.get(`/master/device_log?findField=${param.findField}&findValue=${param.findValue}&page=${param.page}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  addDeviceLog(data) {
    return axiosInstance.post('/master/device_log', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  updateDeviceLog(data, id) {
    return axiosInstance.put(`/master/device_log/${id}`, data, {
      cancelToken: getNewCancelToken(),
    });
  },
  deleteLogDevice(id) {
    return axiosInstance.delete(`/master/device_log/${id}`, {
      cancelToken: getNewCancelToken(),
    });
  },

  // Device
  /**
   * GET `/master/device` — daftar device.
   *
   * Punya DUA jalur param yang jalan barengan: object lewat `config.params`, ATAU
   * string query mentah lewat `queryString` yang ditempel langsung ke URL. Yang kedua
   * dipakai buat bentuk yang gak bisa dirakit axios, mis. `finds[k][]`. Kalau
   * dua-duanya diisi, dua-duanya kekirim.
   *
   * @param {Object} [config] config axios; filter dan pagination di `config.params`
   * @param {string} [queryString] query mentah TANPA tanda tanya di depan, gak
   *   di-encode
   * @returns {Promise<import('axios').AxiosResponse<import('@/services/_AxiosInstance').MasterListBody>>}
   *   response axios utuh — jalur bacanya `res.data.data`
   */
  getDevices(config, queryString = '') {
    const url = queryString ? `/master/device?${queryString}` : '/master/device';
    return axiosInstance.get(url, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getDevicesByAssetId(param) {
    return axiosInstance.get(`/master/device?findField=${param.findField}&findValue=${param.findValue}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  /**
   * GET `/master/device?findField=devcMassId&findValue={massId}&limit=100` — device
   * milik satu asset.
   *
   * RAGU: `limit=100` dipatok di URL sini, sementara endpoint yang SAMA dipanggil
   * lewat getDevices pakai `max: 1000` (src/components/config/ae/Form.vue:156).
   * Salah satu nama itu pasti diabaikan backend. Jangan diseragamkan sebelum dicek
   * ke payload nyata — kalau ternyata `limit` yang diabaikan, asset dengan lebih
   * dari 100 device diam-diam kepotong.
   *
   * Catatan terpisah: src/store/asset.js:339 ngerakit `{ findField, findValue,
   * max: 100 }` lalu ngasihnya ke getDevicesByAssetId, yang cuma baca findField sama
   * findValue — `max` di situ gak pernah kekirim ke backend sama sekali.
   *
   * @param {number|string} massId id asset
   * @returns {Promise<import('axios').AxiosResponse<import('@/services/_AxiosInstance').MasterListBody>>}
   *   response axios utuh — jalur bacanya `res.data.data`
   */
  getDeviceByMassId(massId) {
    return axiosInstance.get(`/master/device?findField=devcMassId&findValue=${massId}&limit=100`, {
      cancelToken: getNewCancelToken(),
    });
  },
  addDevice(data) {
    return axiosInstance.post('/master/device', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  updateDevice(data, id) {
    return axiosInstance.put(`/master/device/${id}`, data, {
      cancelToken: getNewCancelToken(),
    });
  },
  deleteDevice(id) {
    return axiosInstance.delete(`/master/device/${id}`, {
      cancelToken: getNewCancelToken(),
    });
  },

  // Series
  getSeriesDeviceWeekly(config) {
    return axiosInstance.get('/series/base/last/1/week', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
};
